<template>
    <div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="modifyTime" label="修改时间" width="160"></el-table-column>
                <el-table-column prop="modifyUserName" label="修改人" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="desc" label="修改内容">
                    <template slot-scope="{row} = scope">
                        <div class="desc">{{ row.desc }}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
const defaultParams = {
    pageNo:1,
    agentUserId: ""
}
export default {
    props:{
        id: {
            type: [Number, String],
            default: ""
        }
    },
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                agentUserId: parseInt(this.$route.query.agentUserId || this.id)
            },
            listLoading: true,
            redirect: this.$route.query.redirect || '/finance/agent/manage/list',
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/agent/log",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
                    this.data = null;
					this.dataList = [];
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
    }
}
</script>

<style lang="scss" scoped>
.desc{
    white-space: pre-wrap;
}
</style>